const host = window.location.hostname;
const isHttps = window.location.protocol === 'https:';
const isLocal = host === 'localhost' || host === '127.0.0.1';
const isPrivateIP =
    /^10\./.test(host) ||
    /^172\.(1[6-9]|2\d|3[0-1])\./.test(host) ||
    /^192\.168\./.test(host);
const isIPv4 = /^(?:\d{1,3}\.){3}\d{1,3}$/.test(host);

const isDevLike = !isHttps || isLocal || isPrivateIP || isIPv4;

function cookieAttrs() {
    if (isHttps) {
        return "Path=/; SameSite=None; Secure";
    } else {
        return "Path=/; SameSite=Lax";
    }
}

function setCookie(name, value, days) {
    const encoded = encodeURIComponent(value);
    const expires =
        typeof days === "number"
            ? `; Expires=${new Date(Date.now() + days * 864e5).toUTCString()}`
            : "";
    const str = `${name}=${encoded}; ${cookieAttrs()}${expires}`;
    document.cookie = str;

    if (!document.cookie.includes(`${name}=`)) {
        console.warn(`[Cookie] "${name}" not set. Check protocol/SameSite/Secure.`, { attempted: str });
    }
}

function getCookie(name) {
    const m = document.cookie.match(
        new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)')
    );
    return m ? decodeURIComponent(m[1]) : '';
}

function removeCookie(name) {
    const securePart = isHttps ? "; Secure" : "";
    document.cookie = `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=${isHttps ? "None" : "Lax"}${securePart}`;
}

export const CookiePolicy = {
    isHttps,
    isDevLike,
    cookieAttrs,
    setCookie,
    getCookie,
    removeCookie
};